import React, { FC, useMemo } from 'react';
import { openLinksInNewTab } from 'utils/richText';
import { useRichTextStyles } from './TipTapEditor';

interface RichTextContentProps {
  html: string;
}

const RichTextContent: FC<RichTextContentProps> = ({ html }) => {
  const richTextClasses = useRichTextStyles();
  const content = useMemo(() => openLinksInNewTab(html), [html]);

  return <div className={richTextClasses.richText} dangerouslySetInnerHTML={{ __html: content }} />;
};

export default RichTextContent;
